<template>
  <div class="vms-sms-logs-page">
    <VmsPageHeader
      kicker="Operations"
      title="SMS Logs"
      icon="mdi-message-processing"
    >
      <template #actions>
        <VmsColumnVisibility
          v-model="selectedHeaders"
          :headers="headers"
          @change="toggleColumnVisibility"
        />
      </template>
    </VmsPageHeader>

    <VmsResponsiveList
      :items="smsData"
      :loading="loading"
      loading-text="Loading SMS logs…"
      item-key="sms_id"
    >
      <template #table>
        <v-data-table
          :headers="computedHeaders"
          :items="smsData"
          @row-click="viewDetails"
          :server-items-length="smsDataPagination?.total"
          :options.sync="options"
          :loading="loading"
          loading-text="Loading... Please wait"
          class="elevation-0 vms-surface"
        >
          <template v-slot:no-data>
            <a class="info--text text--darken-1">
              No SMS Logs Found.
              Please contact support for assistance.
            </a>
          </template>

          <template v-slot:item.sent_date="{ item }">
            {{ formatDate(item.sent_date) }}
          </template>

          <template v-slot:item.message="{ item }">
            <div>
              <span v-if="!showFullMessage">{{ formatMessage(item.message) }}</span>
              <span v-if="showFullMessage">{{ item.message }}</span>
              <v-btn small text @click="viewFullMessage(item)">{{ showFullMessage ? 'Show Less' : 'View More' }}</v-btn>
            </div>
          </template>
        </v-data-table>
      </template>

      <template #card="{ item }">
        <div class="vms-list-card__title">{{ item.phone }}</div>
        <div class="vms-list-card__meta">
          <span>{{ formatDate(item.sent_date) }}</span>
          <span>{{ item.user_name }}</span>
        </div>
        <div class="vms-list-card__row">
          <span>{{ formatMessage(item.message) }}</span>
        </div>
        <div class="vms-list-card__actions">
          <v-btn small text color="primary" @click="viewDetails(item)">View details</v-btn>
        </div>
      </template>

      <template #empty>
        <div class="vms-empty">
          <a class="info--text text--darken-1">
            No SMS Logs Found.
            Please contact support for assistance.
          </a>
        </div>
      </template>
    </VmsResponsiveList>

    <v-dialog v-if="selectedSms" v-model="detailsDialog" max-width="600">
      <v-card>
        <v-card-title class="headline">{{ selectedSms.message }}</v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item v-for="(value, key) in selectedSmsDetails" :key="key">
              <v-list-item-content>
                <v-list-item-title>{{ key }}</v-list-item-title>
                <v-list-item-subtitle>{{ value }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="detailsDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import ReportsService from "@/services/reports.service";
import moment from "moment";
import VmsPageHeader from "../../components/VmsPageHeader.vue";
import VmsResponsiveList from "../../components/VmsResponsiveList.vue";
import VmsColumnVisibility from "../../components/VmsColumnVisibility.vue";
import columnVisibility from "../../mixins/columnVisibility";

export default {
  name: "SmsLogs",
  components: {
    VmsPageHeader,
    VmsResponsiveList,
    VmsColumnVisibility,
  },
  mixins: [columnVisibility],
  data() {
    return {
      headers: [
        { text: "SMS ID", value: "sms_id", visible: true },
        { text: "Message", value: "message", visible: true },
        { text: "Phone", value: "phone", visible: true },
        { text: "Sent Date", value: "sent_date", visible: true },
        { text: "User Name", value: "user_name", visible: false },
      ],
      smsData: [],
      selectedSms: null,
      selectedSmsDetails: {},
      detailsDialog: false,
      loading: false,
      showFullMessage: false,
      smsDataPagination: {},
      options: {},
    };
  },
  methods: {
    viewDetails(item) {
      this.selectedSms = item;
      this.selectedSmsDetails = {
        "SMS ID": item.sms_id,
        Phone: item.phone,
        "Sent Date": this.formatDate(item.sent_date),
        "User Name": item.user_name,
      };
      this.detailsDialog = true;
    },
    getSmsLogs() {
      const org_id = 1;
      this.loading = true;
      ReportsService.smsLogs(org_id, { options: this.options })
        .then((response) => {
          if (response.status === 200) {
            this.smsData = response.data?.data?.data;
            this.smsDataPagination = response?.data?.data;
          }
        })
        .catch((error) => {
          this.$store.dispatch("alert/error", error.response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDate(date, format = 'DD-MMM-YYYY') {
      return moment(date).format(format);
    },
    formatMessage(message) {
      if (message.length > 70) {
        return message.substring(0, 100) + "...";
      } else {
        return message;
      }
    },
    viewFullMessage(item) {
      this.detailsDialog = true;
      this.selectedSms = item;
    },
  },
  watch: {
    options: {
      handler () {
        this.getSmsLogs();
      },
      deep: true,
    },
  },
  created() {
    this.initColumnVisibility();
  },
};
</script>
